// Links in posts, comments and profiles are user content. Only web and mail
// links and relative references (same-site paths, ./ and ../, ?query, #anchor)
// may become an href or be opened: a javascript: or data: URL runs its code
// with this site's origin. Browsers drop tabs and newlines anywhere in a URL
// and control characters and spaces in front of it (java\nscript: is
// javascript:), so the scheme is read the same way. Same rule as the
// renderer's sanitizer.
const SAFE_SCHEMES = ['http', 'https', 'mailto', 'tel'];

// The link target when it is safe to link to, otherwise null.
export const safeHref = value => {
  if (typeof value !== 'string') return null;
  // eslint-disable-next-line no-control-regex
  const href = value.replace(/[\t\n\r]/g, '').replace(/^[\u0000-\u0020]+/, '');
  const scheme = /^([a-z][a-z0-9+.-]*):/i.exec(href);
  return !scheme || SAFE_SCHEMES.includes(scheme[1].toLowerCase())
    ? href
    : null;
};

// decodeURIComponent throws on a malformed sequence such as a lone '%'.
export const safeDecode = value => {
  try {
    return decodeURIComponent(value);
  } catch {
    return null;
  }
};
